import request from '@/utils/request'

// 客服会话列表（参数可含 province/city/role）
export function getConversations(scopeParams = {}) {
  return request({
    url: '/admin/customer-service/conversations',
    method: 'get',
    params: scopeParams
  })
}

// 某条子会话的完整消息（userId + 可选 agentId；参数可含 province/city/role）
export function getConversationMessages(userId, agentId, scopeParams = {}) {
  const params = Object.assign({}, scopeParams)
  if (agentId !== undefined && agentId !== null) {
    params.agentId = agentId
  }
  return request({
    url: `/admin/customer-service/messages/${userId}`,
    method: 'get',
    params
  })
}

// 客服回复某条子会话（data 含 userId、可选 agentId、content）
export function replyConversation(data, scopeParams = {}) {
  return request({
    url: '/admin/customer-service/reply',
    method: 'post',
    params: scopeParams,
    data
  })
}

// 未读总数（用户发来未读的消息数，按当前选择区域过滤）——侧边栏红点用
export function getUnreadTotal(regionParams = {}) {
  return request({
    url: '/admin/customer-service/unread-total',
    method: 'get',
    params: regionParams
  })
}
